import Icon from '../components/Icon.vue'

Icon.register({
  'vector-square': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 128V32C512 14.3 497.7 0 480 0H384C366.3 0 352 14.3 352 32H160C160 14.3 145.7 0 128 0H32C14.3 0 0 14.3 0 32V128C0 145.7 14.3 160 32 160V352C14.3 352 0 366.3 0 384V480C0 497.7 14.3 512 32 512H128C145.7 512 160 497.7 160 480H352C352 497.7 366.3 512 384 512H480C497.7 512 512 497.7 512 480V384C512 366.3 497.7 352 480 352V160C497.7 160 512 145.7 512 128zM416 64H448V96H416V64zM64 64H96V96H64V64zM96 448H64V416H96V448zM448 448H416V416H448V448zM416 352H384C366.3 352 352 366.3 352 384V416H160V384C160 366.3 145.7 352 128 352H96V160H128C145.7 160 160 145.7 160 128V96H352V128C352 145.7 366.3 160 384 160H416V352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vector-square.js
// module id = wQeo
// module chunks = 144